// Global store for File objects to prevent them from being lost during React state updates
// File objects cannot be serialized/cloned through React state, so we store them here

const fileStore = new Map();

export const storeFile = (name, file) => {
  fileStore.set(name, file);
};

export const getFile = (name) => {
  return fileStore.get(name);
};

export const removeFile = (name) => {
  fileStore.delete(name);
};

export const clearFiles = () => {
  fileStore.clear();
};
